export function formatLongDate(date: Date){

    let day = date.getDate().toString();
    let year = date.getFullYear().toString();

    const months = ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
    return day + ". " + months[date.getMonth()] + " " + year;
}